import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

const AppBreadcrumb = ({ items = [] }) => {
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <div className="mb-3">
      <Breadcrumb className="mb-1">
        {items.map((it, idx) => (
          <Breadcrumb.Item
            key={idx}
            linkAs={it.to ? Link : "span"}
            linkProps={it.to ? { to: it.to } : undefined}
            active={idx === items.length - 1}
          >
            {it.label}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default AppBreadcrumb;


